
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 3c7.168 0 13 5.832 13 13s-5.832 13-13 13S3 23.168 3 16 8.832 3 16 3zm-1.125 2.063a10.967 10.967 0 00-9.813 9.938H6v2h-.938A10.957 10.957 0 0015 26.939v-.938h2v.938a10.957 10.957 0 009.938-9.938H26v-2h.938A10.957 10.957 0 0017 5.063v.938h-2v-.938c-.041.004-.084-.004-.125 0zm7.219 4.843l-3.688 8.5-8.5 3.688 3.688-8.5zM16 14.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5z"}})])
          )
        }
      }
    